import { useCallback } from 'react'

import { DrawingParameterTextAnnotation, DrawingType } from '@editor/interfaces/drawing'
import { EditorPanelItem, ElementsPanelConfig } from '@editor/interfaces/editor'
import { removeDrawings } from '@editor/pages/projects/blueprint-editor/store/drawings'
import { getDrawingsOfType } from '@editor/services/Drawing'
import { RootState, useAppDispatch } from '@editor/store/app'
import { resetElement } from '@editor/store/tool'
import { useSelector } from 'react-redux'

const useDrawingsPanel = (): ElementsPanelConfig => {
  // Store
  const dispatch = useAppDispatch()
  const drawings = useSelector((state: RootState) => state.blueprint.drawings.document.drawings)

  return {
    getPanelItems: useCallback(
      (parent?: EditorPanelItem['item']): EditorPanelItem[] => {
        if (parent) return [] as EditorPanelItem[]

        return getDrawingsOfType<DrawingParameterTextAnnotation>(drawings, DrawingType.TextAnnotation, []).map(
          (item, index) => ({
            key: `tool-text-annotation-${item.drawing_parameters.uuid}`,
            name: item.name || `注釈 ${index + 1}`,
            item,
            onDelete: () => {
              dispatch(removeDrawings([item.drawing_parameters.uuid]))
              dispatch(resetElement(item.drawing_parameters.uuid))
            },
          }),
        )
      },
      [drawings, dispatch],
    ),
  }
}

export default useDrawingsPanel
